import { useTranslation } from "react-i18next";

const equipmentItems = [
  { no: "01", nameKey: "item1Name", priceKey: "item1Price" },
  { no: "02", nameKey: "item2Name", priceKey: "item2Price" },
  { no: "03", nameKey: "item3Name", priceKey: "item3Price" },
  { no: "04", nameKey: "item4Name", priceKey: "item4Price" },
  { no: "05", nameKey: "item5Name", priceKey: "item5Price" },
  { no: "06", nameKey: "item6Name", priceKey: "item6Price" },
  { no: "07", nameKey: "item7Name", priceKey: "item7Price" },
  { no: "08", nameKey: "item8Name", priceKey: "item8Price" },
];

export default function EquipmentSupport() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-midnight py-32 md:py-44 overflow-hidden">
      {/* Top border accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-champagne/40 to-transparent" />

      <div className="w-full px-6 md:px-12 lg:px-16 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Tag */}
          <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-8">
            {t("pricing.equipment.tag")}
          </span>

          {/* Main headline */}
          <h2 className="text-marble font-serif text-3xl md:text-4xl lg:text-5xl font-light tracking-wide leading-snug mb-4">
            {t("pricing.equipment.title")}
          </h2>

          {/* Catchphrase */}
          <p className="text-champagne font-serif text-lg md:text-xl font-light tracking-wide mb-10">
            {t("pricing.equipment.catchphrase")}
          </p>

          {/* Highlighted key message */}
          <div className="relative inline-block bg-gradient-to-br from-champagne/15 via-champagne/8 to-transparent rounded-2xl border border-champagne/30 px-8 md:px-14 py-8 md:py-10 mb-16 md:mb-20">
            <p className="text-champagne font-serif text-xl md:text-2xl lg:text-3xl font-light tracking-wide leading-relaxed max-w-2xl whitespace-pre-line">
              {t("pricing.equipment.subtitle")}
            </p>
          </div>

          {/* Equipment list card */}
          <div className="rounded-2xl border border-white/5 bg-charcoal/10 p-8 md:p-10 max-w-xl mx-auto text-left">
            <h3 className="text-marble font-serif text-lg md:text-xl font-light tracking-wide mb-2">
              {t("pricing.equipment.essentialsTitle")}
            </h3>
            <p className="text-marble/40 text-xs font-sans tracking-wide mb-8">
              {t("pricing.equipment.essentialsSub")}
            </p>

            <ul className="space-y-4">
              {equipmentItems.map((item) => (
                <li key={item.no} className="flex items-center justify-start gap-3">
                  <span className="text-champagne/60 text-xs font-sans tracking-wider w-6 shrink-0 text-right">
                    {item.no}
                  </span>
                  <span className="text-marble/80 text-sm font-sans leading-relaxed whitespace-pre-line">
                    {t(`pricing.equipment.${item.nameKey}`)}
                  </span>
                </li>
              ))}
            </ul>

            <p className="text-warmgray/50 text-xs font-sans mt-6 pt-4 border-t border-white/5 leading-relaxed whitespace-pre-line">
              {t("pricing.equipment.essentialsNote")}
            </p>
          </div>

          {/* CTA */}
          <div className="mt-12">
            <a
              href="/inquiry"
              className="inline-flex items-center gap-3 bg-champagne hover:bg-champagne/90 text-deepblack px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300"
            >
              {t("pricing.equipment.cta")}
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom border accent */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-champagne/40 to-transparent" />
    </section>
  );
}